import React from 'react';
import { useTranslation } from 'react-i18next';
import Logo from './company/Logo';
import FooterLinks from './footer/FooterLinks';
import FooterContact from './footer/FooterContact';
import FooterCopyright from './footer/FooterCopyright';

const Footer = () => {
  const { t } = useTranslation('footer');

  return (
    <footer className="relative bg-slate-950 text-white overflow-hidden border-t border-white/5">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-cyan-400/40 to-transparent" />
      <div className="pointer-events-none absolute -bottom-40 left-1/2 -translate-x-1/2 w-[800px] h-[300px] rounded-full bg-blue-600/10 blur-[100px]" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="col-span-1 md:col-span-2">
            <Logo size="sm" />
            <p className="mt-6 text-slate-400 leading-relaxed max-w-md">{t('description')}</p>
          </div>
          <FooterLinks />
          <FooterContact />
        </div>

        <div className="mt-12 pt-8 border-t border-white/10">
          <FooterCopyright />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
